import { z } from 'zod'

export const PolicyCitationAgentInputSchema = z.object({
  type: z.literal('policy'),
  policyName: z.string().describe('Policy name'),
  anchor: z.string().describe('Verbatim 5–10 word phrase from the policy'),
})

const DocumentCitationFieldsSchema = {
  fileStoreId: z.string(),
  pageNumber: z.number().optional(),
  heading: z.string().optional(),
}

export const PolicyCitationResolvedSchema = z.object({
  sourceType: z.literal('policy'),
  sourceLabel: z.string(),
  fileName: z.string().optional(),
  quote: z.string().optional(),
  policyId: z.string(),
  policyVersionId: z.string(),
  ...DocumentCitationFieldsSchema,
})
export type PolicyCitationResolved = z.infer<typeof PolicyCitationResolvedSchema>
